import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type UpdateQuoteRequestTransport = ClientInferResponseBody<
  typeof contract.quoteRequests.updateTransport
>;

export type UpdateQuoteRequestTransportDto = ClientInferRequest<
  typeof contract.quoteRequests.updateTransport
>["body"];

export const updateQuoteRequestTransport = async ({
  id,
  payload,
}: {
  id: string;
  payload: UpdateQuoteRequestTransportDto;
}): Promise<UpdateQuoteRequestTransport> => {
  const response = await api.quoteRequests.updateTransport.mutation({
    params: {
      id,
    },
    body: payload,
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError(
    "Failed to update transport for quote request",
    response.status,
    response.body,
  );
};
